import React, { useState } from "react";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { sendHtmlEmail } from "../emailapi"; 

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: ""
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      await sendHtmlEmail(
        "bnsmahilamahavidyalaya@gmail.com",
        "New Contact Form Submission",
        formData
      );

      alert("Message Sent Successfully ✅");

      setFormData({
        name: "",
        email: "",
        phone: "",
        message: ""
      });

    } catch (error) {
      console.error(error);
      alert("Email send failed ❌");
    } finally {
      setLoading(false);
    }
  };

  const mapLink =
    "https://www.google.com/maps/place/BNS+Mahila+Mahavidyalaya,+Akhari+Bai-Pass,+Varanasi";

  return (
    <div className="w-full min-h-screen bg-gradient-to-br from-red-50 via-white to-yellow-50 py-12">

      <div className="w-full px-6 lg:px-16">

        {/* Heading */}
        <h1 className="text-4xl font-bold text-center mb-12">
          <span className="bg-gradient-to-r from-red-600 via-orange-500 to-yellow-500 bg-clip-text text-transparent">
            Contact Us
          </span>
        </h1>

        <div className="grid lg:grid-cols-2 gap-12 mb-12">

          {/* LEFT */}
          <div className="space-y-6">
            {[
              {
                icon: <MapPin />,
                title: "Address",
                text: "Akhari Bai-Pass, Varanasi, Uttar Pradesh - 221011"
              },
              {
                icon: <Phone />,
                title: "Phone",
                text: "+91 7080100324"
              },
              {
                icon: <Mail />,
                title: "Email",
                text: "bnsmahilamahavidyalaya@gmail.com"
              },
              {
                icon: <Clock />,
                title: "Working Hours",
                text: "Mon - Sat: 9 AM - 5 PM"
              }
            ].map((item, i) => (
              <div
                key={i}
                className="group flex gap-4 bg-white p-6 rounded-2xl shadow-md hover:shadow-2xl transition"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-r from-red-500 to-yellow-500 text-white">
                  {item.icon}
                </div>
                <div>
                  <h3 className="font-semibold text-gray-800 text-lg">
                    {item.title}
                  </h3>
                  <p className="text-sm text-gray-600">{item.text}</p>
                </div>
              </div>
            ))}
          </div>

          {/* RIGHT FORM */}
          <div className="relative bg-white p-8 rounded-2xl shadow-xl overflow-hidden">

            <div className="absolute -top-10 -right-10 w-40 h-40 bg-yellow-200 opacity-40 rounded-full blur-3xl"></div>
            <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-red-200 opacity-40 rounded-full blur-3xl"></div>

            <h2 className="text-2xl font-bold mb-6 text-red-600">
              Send Message
            </h2>

            <form onSubmit={handleSubmit} className="space-y-5 relative z-10">

              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Full Name"
                required
                className="w-full border px-4 py-3 rounded-xl focus:outline-none focus:border-red-500 focus:ring-2 focus:ring-red-100"
              />

              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email Address"
                required
                className="w-full border px-4 py-3 rounded-xl focus:outline-none focus:border-red-500 focus:ring-2 focus:ring-red-100"
              />

              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Phone Number"
                required
                className="w-full border px-4 py-3 rounded-xl focus:outline-none focus:border-red-500 focus:ring-2 focus:ring-red-100"
              />

              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="4"
                placeholder="Your Message"
                required
                className="w-full border px-4 py-3 rounded-xl focus:outline-none focus:border-red-500 focus:ring-2 focus:ring-red-100"
              ></textarea>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-gradient-to-r from-red-600 to-yellow-500 text-white py-3 rounded-xl font-semibold hover:shadow-xl"
              >
                {loading ? "Sending..." : "Send Message"}
              </button>

            </form>
          </div>

        </div>

        {/* MAP */}
        <div className="relative bg-white rounded-2xl shadow-xl overflow-hidden">

          <div className="h-1 bg-gradient-to-r from-red-600 to-yellow-500"></div>

          <a href={mapLink} target="_blank" rel="noopener noreferrer">
            <iframe
              src="https://www.google.com/maps?q=BNS+Mahila+Mahavidyalaya+Varanasi&output=embed"
              width="100%"
              height="400"
              style={{ border: 0 }}
              loading="lazy"
              title="College Map"
              className="cursor-pointer"
            ></iframe>
          </a>

          <div className="flex justify-center gap-4 py-5">
            <a
              href={mapLink}
              target="_blank"
              className="bg-red-600 text-white px-6 py-2 rounded-lg"
            >
              Open College Location
            </a>

            <a
              href="https://www.google.com/maps/dir/?api=1&destination=BNS+Mahila+Mahavidyalaya+Varanasi"
              target="_blank"
              className="bg-yellow-500 text-white px-6 py-2 rounded-lg"
            >
              Get Directions
            </a>
          </div>

        </div>

      </div>
    </div>
  );
};

export default ContactPage;